import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Store } from '@ngrx/store';
import { selectIfAdministrator } from 'app/reducers/context.selectors';
import { Observable } from 'rxjs';

/**
 * Строго роль Administrator. AdminGuard здесь не подходит: он пускает ещё и Support,
 * а настройки приложения влияют на все хосты хаба сразу.
 */
@Injectable()
export class AdministratorGuard implements CanActivate {
  constructor(private store: Store) {
  }

  canActivate(): Observable<boolean> {
    return this.store.select(selectIfAdministrator);
  }
}
